import * as player from '../player.js';
import * as scene from '../scene.js';
import * as loader from '../loader.js';
import * as audio from '../audio.js';

export {
    init,
}

const POIs = [
    {
        name: 'chewing-gum',
        position: { x: -19, y: -13, z: 0 },
        color: 'white',
        sound: {
            name: 'chewing-gum',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
];

const sounds = [
    { name: 'chewing-gum', url: new URL('../../sound/ChewingGum.wav', import.meta.url) },
];

const images = [
];

function init() {
    scene.addPOIs(POIs);
    //loader.addImages(images);
    loader.addSounds(sounds);
};
